// Strict reader for POST /admin/access/campaign-bindings/retire (kept out of the component file).

export const RETIRE_PATH = "/admin/access/campaign-bindings/retire";

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null && !Array.isArray(value);

/** Fail-closed: exactly { retired: boolean, correlation_id: non-empty string, detail: { state: string, ... } }. */
export function readRetireResponse(value: unknown): { retired: boolean } | null {
  if (!isRecord(value) || Object.keys(value).length !== 3) return null;
  if (typeof value.retired !== "boolean") return null;
  if (typeof value.correlation_id !== "string" || value.correlation_id.length === 0) return null;
  if (!isRecord(value.detail) || typeof value.detail.state !== "string" || value.detail.state.length === 0) return null;
  return { retired: value.retired };
}
